module.exports = __webpack_public_path__ + "static/showroom3-8ddad12647571aa836b87436f057fe0e.jpg";